/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerUpdateMutationRequest, ProjectsControllerUpdateMutationResponse, ProjectsControllerUpdatePathParams, ProjectsControllerUpdate400, ProjectsControllerUpdate401, ProjectsControllerUpdate403, ProjectsControllerUpdate404 } from "../../models/projectsController/ProjectsControllerUpdate";

function getProjectsControllerUpdateUrl(id: ProjectsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/projects/${id}` as const }  
  return res
}

/**
 * @summary Update a project
 * {@link /api/v1/projects/:id}
 */
export async function projectsControllerUpdate(id: ProjectsControllerUpdatePathParams["id"], data?: ProjectsControllerUpdateMutationRequest, config: Partial<RequestConfig<ProjectsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectsControllerUpdateMutationResponse, ResponseErrorConfig<ProjectsControllerUpdate400 | ProjectsControllerUpdate401 | ProjectsControllerUpdate403 | ProjectsControllerUpdate404>, ProjectsControllerUpdateMutationRequest>({ method : "PATCH", url : getProjectsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}